/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopUpBillingWalletData
 */
export interface TopUpBillingWalletData {
    /**
     * 
     * @type {number}
     * @memberof TopUpBillingWalletData
     */
    billingProductPriceId: number;
    /**
     * 
     * @type {string}
     * @memberof TopUpBillingWalletData
     */
    successPath: string;
    /**
     * 
     * @type {string}
     * @memberof TopUpBillingWalletData
     */
    cancelPath: string;
}

/**
 * Check if a given object implements the TopUpBillingWalletData interface.
 */
export function instanceOfTopUpBillingWalletData(value: object): value is TopUpBillingWalletData {
    if (!('billingProductPriceId' in value) || value['billingProductPriceId'] === undefined) return false;
    if (!('successPath' in value) || value['successPath'] === undefined) return false;
    if (!('cancelPath' in value) || value['cancelPath'] === undefined) return false;
    return true;
}

export function TopUpBillingWalletDataFromJSON(json: any): TopUpBillingWalletData {
    return TopUpBillingWalletDataFromJSONTyped(json, false);
}

export function TopUpBillingWalletDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopUpBillingWalletData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingProductPriceId': json['billingProductPriceId'],
        'successPath': json['successPath'],
        'cancelPath': json['cancelPath'],
    };
}

  export function TopUpBillingWalletDataToJSON(json: any): TopUpBillingWalletData {
      return TopUpBillingWalletDataToJSONTyped(json, false);
  }

  export function TopUpBillingWalletDataToJSONTyped(value?: TopUpBillingWalletData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingProductPriceId': value['billingProductPriceId'],
        'successPath': value['successPath'],
        'cancelPath': value['cancelPath'],
    };
}

